import { render, staticRenderFns } from "./AvaliarConsultaView.vue?vue&type=template&id=d83a3c56&scoped=true"
import script from "./AvaliarConsultaView.vue?vue&type=script&lang=js"
export * from "./AvaliarConsultaView.vue?vue&type=script&lang=js"
import style0 from "./AvaliarConsultaView.vue?vue&type=style&index=0&id=d83a3c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83a3c56",
  null
  
)

export default component.exports